import { useEffect, useRef } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { useIScroll } from "src/modules/pe-landing-module/hooks/useIScroll"
import { BACKGROUND_EFFECT_TYPE, } from "../../../../data/interfaces"
import { IBackgroundProps } from "../Background"
import { getDarker } from "src/libs/utilities/colors"

/* Protopia Ecosystem component */ 
const BackgroundMademoiselle = ({section, ...props}: IBackgroundProps): JSX.Element => {
    const {color, color_size, color_contrast, color_rotate, opacity, image, image_opacity, parallax_speed, parallax_y_offset, effect, image_mask, stack, } = section.background || {}
    const bgRef = useRef(null)
    const scroll  = useIScroll( bgRef, effect )
    
    useEffect(() => { 
        const lighten = color || "#657385"
        const darken = getDarker( lighten, color_contrast || 75 )
        const sz = color_size || 10
        const halfSz = sz / 2 
        addCSSClass(
            `section-bg-mademoiselle-${section.id}`,
            `.section-bg-mademoiselle-color-${section.id} {
                background: repeating-linear-gradient(${color_rotate || 0}deg, ${darken}, ${darken} ${halfSz}px, ${lighten} ${halfSz}px, ${lighten} ${sz}px);
                opacity: ${opacity || 1};
                z-index:${  stack === "image" ? 0 : 1};
            }
            .section-bg-mademoiselle-image-${section.id} {
                ${ image ? `background-image:url(${image});` : ``}
                opacity: ${image_opacity || 1};
                z-index:${ stack === "color" ? 0 : 1};
                ${ image_mask ? `mask-image: ${ image_mask};` : ``}
            }`
        )        
        return () => {
            removeCSSClass(`section-bg-mademoiselle-${section.id}`)
        }
    }, [])


    let poffset, backgroundAttachment = ""
    switch ( effect ) {
      case BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX:
        backgroundAttachment = "fixed"
        poffset = scroll * ( parallax_speed || -0.1 ) - ( parallax_y_offset || 4 )
        break
      case BACKGROUND_EFFECT_TYPE.FIXED:
        backgroundAttachment = "fixed"
        poffset = scroll - ( parallax_y_offset || 0 )
        break
      default:
        backgroundAttachment = ""
        poffset = 0
    }
 
    return <>
        <div className={`landing-section-bg-color section-bg-mademoiselle-color-${section.id}`} />
        <div 
            className={`landing-section-bg-image section-bg-mademoiselle-image-${section.id}`} 
            ref={bgRef} 
            style={{
                backgroundPositionY : poffset,
                backgroundAttachment
            }}
        />
      </>
}
export default BackgroundMademoiselle